import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X7PushableBlock,
  X7PushableBlockUpdateModel
} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditPushableBlockStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly pushableBlock: X7PushableBlock) {
    makeObservable(this);
    this.name = new StringControl(
      'name', pushableBlock.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X7PushableBlockUpdateModel = {
      PageId: this.pushableBlock.PageId,
      Index: this.pushableBlock.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x7pushableBlock.update(this.pushableBlock.Id, model);
  }
}
